<template>
    <v-card>
        <v-form ref="pagingSubstitutionForm" v-model="formValid" :lazy-validation="true">
            <v-card-title>{{ `${$props.pagingSubstitution.ps_id > -1 ? 'Edit' : 'New'} Paging Substitution` }}</v-card-title>

            <v-divider />

            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-datetime-picker label="Begin Date/Time" v-model="$props.pagingSubstitution.ps_begin" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="textFieldProps"></v-datetime-picker>
                    </v-col>
                    <v-col cols="12">
                        <v-datetime-picker label="End Date/Time" v-model="$props.pagingSubstitution.ps_end" :timeFormat="'HH:mm:ss'" :datePickerProps="dpProps" :timePickerProps="tpProps" :textFieldProps="textFieldProps"></v-datetime-picker>
                    </v-col>
                    <v-col cols="12">
                        <v-radio-group v-model="$props.pagingSubstitution.substitution_type" row>
                            <v-radio label="User" value="user" color="#c42111"></v-radio>
                            <v-radio label="Group" value="group" color="#c42111"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <template v-if="$props.pagingSubstitution.substitution_type == 'user'">
                        <v-col cols="12">
                            <v-autocomplete label="Original User" v-model="$props.pagingSubstitution.user_id" :items="$props.usersList" item-text="user_fullname" item-value="user_id" color="#c42111" :rules="[validation.required($props.pagingSubstitution.user_id)]" />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete label="Substitute User" v-model="$props.pagingSubstitution.subst_user_id" :items="$props.usersList" item-text="user_fullname" item-value="user_id" color="#c42111" :rules="[validation.required($props.pagingSubstitution.subst_user_id), validation.uniqueValue($props.pagingSubstitution.substitution_type == 'user', $props.pagingSubstitution.user_id, $props.pagingSubstitution.subst_user_id, 'You cannot substitute the same user.')]" />
                        </v-col>
                    </template>
                    <template v-else-if="$props.pagingSubstitution.substitution_type == 'group'">
                        <v-col cols="12">
                            <v-autocomplete label="Original Group" v-model="$props.pagingSubstitution.group_id" :items="$props.groupsList" item-text="group_name" item-value="group_id" color="#c42111" :rules="[validation.required($props.pagingSubstitution.group_id)]" />
                        </v-col>
                        <v-col cols="12">
                            <v-autocomplete label="Substitute Group" v-model="$props.pagingSubstitution.subst_group_id" :items="$props.groupsList" item-text="group_name" item-value="group_id" color="#c42111" :rules="[validation.required($props.pagingSubstitution.subst_group_id), validation.uniqueValue($props.pagingSubstitution.substitution_type == 'group', $props.pagingSubstitution.group_id, $props.pagingSubstitution.subst_group_id, 'You cannot substitute the same group.')]" />
                        </v-col>
                    </template>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn text @click="$emit('cancel')">Cancel</v-btn>
                <v-btn text @click="okClick">Ok</v-btn>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
export default {
    name: 'PagingSubstitutionEdit',
    props: ['pagingSubstitution', 'usersList', 'groupsList'],
    components: {

    },
    data: () => ({
        formValid: true,
        validation: {
            required: (value) => (value ? true : false || "Required field"),
            uniqueValue: (active, original, substitue, message) => (!active || (original != substitue) || message)
        },
        tpProps: {
            useSeconds: true,
            format: '24hr',
            color: '#c42111',
        },
        dpProps: {
            color: '#c42111',
        },
        textFieldProps: {
            rules: [
                ((value) => (value ? true : false || "Required field")),
            ],
            error: false,
            "error-messages": []
        }
    }),

    computed: {

    },

    methods: {
        okClick: function() {
            if(TELSA.moment(this.$props.pagingSubstitution.ps_begin) < TELSA.moment(this.$props.pagingSubstitution.ps_end)) {
                this.textFieldProps.error = false;
                this.textFieldProps['error-messages'] = [];
            }
            else {
                this.textFieldProps.error = true;
                this.textFieldProps['error-messages'].push('Begin date/time must be earlier than end date/time');
            }

            if(this.$props.pagingSubstitution.substitution_type == 'user') {
                this.$props.pagingSubstitution.group_id = null;
                this.$props.pagingSubstitution.subst_group_id = null;
            }
            else if(this.$props.pagingSubstitution.substitution_type == 'group') {
                this.$props.pagingSubstitution.user_id = null;
                this.$props.pagingSubstitution.subst_user_id = null;
            }

            if(this.$refs.pagingSubstitutionForm.validate() && !this.textFieldProps.error) {
                this.$emit('ok', this.$props.pagingSubstitution);
            }
        },

    },

    created() {
        if(this.$props.pagingSubstitution.ps_begin) {
            this.$props.pagingSubstitution.ps_begin = TELSA.moment(this.$props.pagingSubstitution.ps_begin).format('YYYY-MM-DD HH:mm:ss');
        }
        if(this.$props.pagingSubstitution.ps_end) {
            this.$props.pagingSubstitution.ps_end = TELSA.moment(this.$props.pagingSubstitution.ps_end).format('YYYY-MM-DD HH:mm:ss');
        }
    }

  
};
</script>
